import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { KeepAlive } from 'react-activation';
import './index.scss';

interface KeepAliveTransitionProps {
  children: React.ReactNode;
  name: string;
  timeout?: number;
  classNames?: string;
}

const KeepAliveTransition: React.FC<KeepAliveTransitionProps> = ({
  children,
  name,
  timeout = 300,
  classNames = 'page-transition',
}) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [animationKey, setAnimationKey] = useState(0);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    // 每次路径变化都触发动画，不管是否是 KeepAlive 组件
    if (prevPathRef.current !== location.pathname) {
      prevPathRef.current = location.pathname;

      // 强制重新渲染动画
      setAnimationKey((prev) => prev + 1);

      // 淡出动画
      setIsVisible(false);

      // 延迟后淡入
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  return (
    <div
      key={animationKey}
      className={`page-transition-wrapper ${classNames} ${isVisible ? 'page-transition-visible' : 'page-transition-hidden'}`}
      style={{
        transition: `opacity ${timeout}ms ease-in-out`,
        opacity: isVisible ? 1 : 0,
      }}
    >
      <KeepAlive name={name} cacheKey={name}>
        {children}
      </KeepAlive>
    </div>
  );
};

export default KeepAliveTransition;
